export default __webpack_public_path__ + "8e61cc320fc0c7b92f40c8e0060c57a3.png";